import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PackageCheck, FolderOpen, Upload } from "lucide-react";
import { ObraEntregaTab } from "./ObraEntregaTab";
import { PlantillasDocumentosManager } from "@/components/configuracion/PlantillasDocumentosManager";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

interface Props {
  obraId: string;
  obraEstado: string;
  open: boolean;
  onClose: () => void;
}

export function ObraEntregaDialog({ obraId, obraEstado, open, onClose }: Props) {
  const { toast } = useToast();
  const [saving, setSaving] = useState(false);

  const setPospuesta = async (pospuesta: boolean) => {
    setSaving(true);
    const { error } = await (supabase as any)
      .from("obras")
      .update({ entrega_pospuesta: pospuesta })
      .eq("id", obraId);
    setSaving(false);
    if (error) {
      toast({ title: "Error", description: error.message, variant: "destructive" });
      return;
    }
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="w-[96vw] max-w-4xl max-h-[92vh] overflow-y-auto p-4 sm:p-6">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <PackageCheck className="h-5 w-5 text-primary" />
            Documentación de entrega de obra
          </DialogTitle>
          <DialogDescription>
            Sube las fotos finales, certificados y checklists firmados con el cliente. Puedes descargar las plantillas
            disponibles desde la pestaña de plantillas. Si lo prefieres, puedes posponer y completarlo más tarde.
          </DialogDescription>
        </DialogHeader>

        <Tabs defaultValue="subir" className="space-y-4">
          <TabsList>
            <TabsTrigger value="subir" className="gap-2">
              <Upload className="h-4 w-4" />
              Subir documentación
            </TabsTrigger>
            <TabsTrigger value="plantillas" className="gap-2">
              <FolderOpen className="h-4 w-4" />
              Plantillas
            </TabsTrigger>
          </TabsList>

          <TabsContent value="subir">
            <ObraEntregaTab obraId={obraId} obraEstado={obraEstado} hideHeader />
          </TabsContent>

          <TabsContent value="plantillas">
            <PlantillasDocumentosManager readOnly />
          </TabsContent>
        </Tabs>

        <DialogFooter className="gap-2">
          <Button variant="outline" disabled={saving} onClick={() => setPospuesta(true)}>
            Más tarde
          </Button>
          <Button disabled={saving} onClick={() => setPospuesta(false)}>
            Hecho
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
